import { render, staticRenderFns } from "./travel_section.vue?vue&type=template&id=df2a69d8&scoped=true&"
import script from "./travel_section.vue?vue&type=script&lang=js&"
export * from "./travel_section.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "df2a69d8",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAlert } from 'vuetify/lib/components/VAlert';
import { VCol } from 'vuetify/lib/components/VGrid';
installComponents(component, {VAlert,VCol})
